import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import style from './DraggableScroll.module.scss';

const DraggableScroll = ({ children, className }) => {
  const containerRef = useRef(null);
  const isDragging = useRef(false);
  const startX = useRef(0);
  const scrollStart = useRef(0);

  const handlePointerDown = (e) => {
    e.preventDefault();
    isDragging.current = true;
    startX.current = e.pageX - containerRef.current.offsetLeft;
    scrollStart.current = containerRef.current.scrollLeft;
    containerRef.current.style.cursor = 'grabbing';
  };

  const handlePointerUp = () => {
    if (isDragging.current) {
      isDragging.current = false;
      containerRef.current.style.cursor = 'grab';
    }
  };

  const handlePointerMove = (e) => {
    if (isDragging.current) {
      e.preventDefault();
      const x = e.pageX - containerRef.current.offsetLeft;
      const walk = x - startX.current;
      containerRef.current.scrollLeft = scrollStart.current - walk;
    }
  };

  return (
    <div
      ref={containerRef}
      className={classNames(style.draggableScroll, className || '')}
      data-testid="draggable-scroll"
      onPointerDown={handlePointerDown}
      onPointerLeave={handlePointerUp}
      onPointerMove={handlePointerMove}
      onPointerUp={handlePointerUp}
      style={{ cursor: 'grab' }}
    >
      {children}
    </div>
  );
};

DraggableScroll.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default DraggableScroll;
